var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFebestUa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "LOGO_FINAL",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 841.9 595.3"
    },
    xmlSpace: "preserve",
    viewBox: "351.7 240.4 138.5 114.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.uast0{fill:#FED600;}\n\t.uast1{fill:#005BBB;}\n\t.uast2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uast0",
    d: "M351.7,297.5v57.1h90.7h6.4h14c15.2,0,27.4-12.3,27.4-27.4v-12.5v-17.2H351.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uast1",
    d: "M490.2,297.5v-57.1h-89.8h-7.3h-14c-15.2,0-27.4,12.3-27.4,27.4v12.5v17.2H490.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uast2",
    d: "M464.6,280.8h-68.3c-2.4,0-3.5,1-3.5,3.1v6.4h71.4v14.6h-71.4V329h-15.4v-43.3v-1.4v-2.7   c0-8.5,6.9-15.5,15.5-15.5l0,0c2.3,0,3.9,0,3.9,0h67.9L464.6,280.8L464.6,280.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFebestUa);
export default __webpack_public_path__ + "static/media/febest_ua.08866ec1.svg";
export { ForwardRef as ReactComponent };